module.exports = __webpack_public_path__ + "static/media/footer-instagram.92b236ab.svg";